import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import { Relayout, RelayoutItem } from 'relayout'

import styles from './metadata-wrapper.css'

const MetadataWrapper = ({ children, className, description, horizontal, label, large }) => (
  <div styleName="metadata-wrapper" className={className}>
    <Relayout>
      <RelayoutItem lg={horizontal ? '4' : '12'}>
        <div styleName={classNames({ 'meta-horizontal': horizontal })}>
          <p styleName={classNames({ 'label-vertical': !horizontal, 'label-horizontal': horizontal })}>
            {label}
          </p>
          {description && <p styleName="description">{description}</p>}
        </div>
      </RelayoutItem>

      <RelayoutItem lg={horizontal ? '8' : '12'}>
        <div styleName={classNames({ 'content-normal': !large, 'content-large': large })}>
          {children}
        </div>
      </RelayoutItem>
    </Relayout>
  </div>
)

MetadataWrapper.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  description: PropTypes.string,
  horizontal: PropTypes.bool,
  label: PropTypes.string,
  large: PropTypes.bool,
}

MetadataWrapper.defaultProps = {
  horizontal: true,
}

export default CSSModules(MetadataWrapper, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/metadata-wrapper/metadata-wrapper.js
 **/